// extracted by mini-css-extract-plugin
export var styles = "sidebar-module--styles--cTJE_";
export var zzz = "sidebar-module--zzz--18Kd0";